import Vue from 'vue';
import VeeValidate from 'vee-validate';
import i18n from '@/translation/i18n';
import validationMessages from 'vee-validate/dist/locale/pl';

import validationDictionary from '@/constants/validationDictionary';
import { excludedCharacters } from '@/constants/validationRules';
import { polishPlurals } from 'polish-plurals';

export default function validationSetUp () {
    const characterLabel = polishPlurals.bind(null, 'znak', 'znaki', 'znaków');

    validationMessages.messages.required = (e, n) => {
        return i18n.messages.pl.errors.field_required_message;
    };
    validationMessages.messages.max = (e, n) => {
        const length = n[0];
        return 'Pole nie może być dłuższe niż ' + length + ' ' + characterLabel(length) + '.';
    };
    validationMessages.messages.decimal = (e, n) => {
        return 'Pole ' + e + ' musi być liczbą i może zawierać ' + n + ' miejsca po kropce.';
    };
    VeeValidate.Validator.localize('pl', { custom: validationDictionary() });
    VeeValidate.Validator.extend('requiredMoreThanZero', {
        getMessage () {
            return i18n.messages.pl.errors.field_required_message;
        },
        validate: (value) => {
            return value != null && value > 0;
        }
    });
    VeeValidate.Validator.extend('is_time', {
        getMessage: (field) => i18n.messages.pl.validation.is_time,
        validate: (value) => {
            const pattern = '([0-1][0-9]|2[0-3])([0-5][0-9])';
            const regex = new RegExp(pattern);
            return value && regex.test(value);
        }
    });
    VeeValidate.Validator.extend(
        'same_names',
        {
            getMessage: (field) => i18n.messages.pl.sheet.sheet_two.change_names.error,
            validate: (value, [other]) => {
                return value.toLowerCase() !== other.toLowerCase();
            }
        },
        { hasTarget: true }
    );
    VeeValidate.Validator.extend('international_phone', {
        getMessage: (field, params, data) => {
            return (data && data.message) || i18n.messages.pl.validation.international_phone;
        },
        validate: (value) => {
            return new Promise((resolve) => {
                const pattern = '^\\+?[0-9]{9,20}$';
                const regex = new RegExp(pattern);
                const trimmed = value.replace(/\s+/g, '');
                resolve({
                    valid: regex.test(trimmed),
                    data:
            trimmed.length > 20
                ? { message: i18n.messages.pl.validation.max__international_phone }
                : undefined
                });
            });
        }
    });
    VeeValidate.Validator.extend('not_allowed_chars', {
        getMessage: (field) => i18n.messages.pl.validation.remove_not_allowed_chars,
        validate: (value) => {
            const regex = new RegExp(excludedCharacters(['basic_not_allowed'], 'i'));
            return value && regex.test(value);
        }
    });
    VeeValidate.Validator.extend('custom_decimal', {
        getMessage: (field) => i18n.messages.pl.validation.custom_decimal,
        validate: (value) => {
            const pattern = '^[0-9]+((\\.|,)[0-9]{1,2})?$';
            const regex = new RegExp(pattern);
            return regex.test(value);
        }
    });
    Vue.use(VeeValidate, {
        dictionary: {
            pl: validationMessages
        },
        locale: 'pl',
        events: 'change|blur'
    });
}
